import { render, staticRenderFns } from "./GuestList2.vue?vue&type=template&id=d6795768&scoped=true"
import script from "./GuestList2.vue?vue&type=script&lang=js"
export * from "./GuestList2.vue?vue&type=script&lang=js"
import style0 from "./GuestList2.vue?vue&type=style&index=0&id=d6795768&prod&scoped=true&lang=css"
import style1 from "./GuestList2.vue?vue&type=style&index=1&id=d6795768&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6795768",
  null
  
)

export default component.exports